import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import TextInput from './TextInput'

class MergeInput extends Component {

    state = {
        fieldName: undefined
    }
    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
        //this.onDelete = this.onDelete.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        state.fieldName = props.step.name
        state.values = props.step.values
        return state
    }

    onChange(type, value) {
        const valueKey = type.blockId
        let values = this.state.values
        values[valueKey] = value
        this.props.onChange(this.props.step.id, this.props.step.name, values)
    }

    render() {
        //const { t } = this.props;

        const colClassName = "col-" + (12 / (this.props.inputTypes.length + 1))
        return <div className="row">
            {this.props.inputTypes.map(type => {
                const valueKey = type.blockId
                return <div className={colClassName} key={valueKey}>
                    <TextInput
                        inputTypes={this.props.inputTypes}
                        onChange={(value) => this.onChange(type, value)}
                        value={this.state.values ? this.state.values[valueKey] : undefined}
                        allowDrop={(e) => e.dataTransfer.types.includes(type.application)}
                    />
                </div>
            })
            }
            <div className={colClassName}>{this.state.fieldName}<button data-toggle="modal" className="btn btn-default icons-list-item" onClick={() => this.props.onDelete(this.props.step)}><i className="fa fa-trash"></i></button></div>
        </div>
    }
}

export default withTranslation()(MergeInput)